import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';
import Passport from "./component/passport/passport";
import Manage from "./component/manage/manage";
import ReactDOM from 'react-dom/client';


const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    // <React.StrictMode>
        <BrowserRouter>
            <Switch>
                <Route path="/passport/*" component={Passport} />
                <Route path="/manage/*" component={Manage} />
                <Redirect to="/passport/login" />
            </Switch>
        </BrowserRouter>
    // </React.StrictMode>
);
